import { buildUri } from './utils/buildUri';
import { Environment } from '../environments';

const AWS_URI_PARAMETERIZED = 'https://(env.)courses.biw.cloud/';

export const buildAwsUri = ( env ) => {
    env = ( env === Environment.LOCAL ) ? Environment.QA : env;
    return buildUri(
        AWS_URI_PARAMETERIZED,
        { env: env },
    );
};
